import React from "react";
import "./CheckoutStepCard.css";

class CheckoutStepCard extends React.Component {
  render() {
    const {
      stepNumber,
      title,
      isActive,
      isCompleted,
      children,
      summaryContent,
    } = this.props;

    return (
      <div
        className={
          "checkout-step-card " +
          (isActive ? "checkout-step-card--active " : "") +
          (isCompleted ? "checkout-step-card--completed " : "")
        }
      >
        <div className="checkout-step-card__header">
          <div className="checkout-step-card__header-left">
            <div
              className={
                "checkout-step-card__number " +
                (isActive ? "checkout-step-card__number--active " : "") +
                (isCompleted ? "checkout-step-card__number--completed " : "")
              }
            >
              {isCompleted && !isActive ? (
                <i className="fa fa-check" style={{ fontSize: "16px" }}></i>
              ) : (
                stepNumber
              )}
            </div>
            <h3 className="checkout-step-card__title">{title}</h3>
          </div>
          {isCompleted && !isActive && summaryContent && (
            <div className="checkout-step-card__summary">
              {summaryContent}
              <button
                type="button"
                className="checkout-step-card__edit"
                onClick={this.props.onEdit}
              >
                Düzenle
              </button>
            </div>
          )}
        </div>
        {isActive && (
          <div className="checkout-step-card__content">{children}</div>
        )}
      </div>
    );
  }
}

export default CheckoutStepCard;



// WEBPACK FOOTER //
// ./src/components/CheckoutStepCard.js